import React from 'react';
import { ShieldCheck } from 'lucide-react';
import './ButtonAutorizar.css';

const ButtonAutorizar = ({ onClick, disabled = false }) => {
  return (
    <button className="boton-autorizar" onClick={onClick} disabled={disabled} title="Autorizar dispositivo">
      <ShieldCheck />
    </button>
  );
};

export default ButtonAutorizar;
